import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-strong-weak-sides-module',
  templateUrl: './strong-weak-sides-module.component.html',
  styles: []
})
export class StrongWeakSidesModuleComponent implements OnInit {
@Input() weakestSides: Array<string>;
@Input() strongestSides: Array<string>;

  constructor() { }

  ngOnInit() {
  }

}
